import type { EventDetails } from "@/modules/eventDetails/client/api/types"
import type { FunctionComponent } from "react"

import { isAfter } from "date-fns"

import IconFire from "@jobteaser/ui-kit/assets/icons/jds_fire.svg"
import { Tag } from "@jobteaser/ui-kit/components/Tag/Tag"

import { WITHOUT_REGISTRATION } from "@/modules/eventDetails/client/constants"
import { useEventDetailsData } from "@/modules/eventDetails/client/hooks/useEventDetailsData"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./SpotsLeft.module.css"

export type SpotsLeftProps = {
  counter: number
}

export const SpotsLeft: FunctionComponent<SpotsLeftProps> = ({ counter }) => {
  const { t } = useTranslation(["event_details"])
  const event = useEventDetailsData()
  const { registrationDetails } = event as EventDetails
  const currentDate = new Date()

  if (registrationDetails.type === WITHOUT_REGISTRATION) {
    return null
  }

  const deadline = new Date(registrationDetails.registrationDeadline ? registrationDetails.registrationDeadline : "")

  if (isAfter(currentDate, deadline)) {
    return null
  }

  return (
    <Tag
      color="purple"
      icon={`#${IconFire.id}`}
      className={styles.spots}
      size="small"
      data-testid="event-details-registration-details-spots-left"
    >
      {t("event_details.spots", { count: counter })}
    </Tag>
  )
}
